import type { SVGProps } from 'react';

const SvgCompanyX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m2.367 3 7.096 10.14L2.74 21h2.64l5.265-6.17L14.96 21h6.91l-7.42-10.625L20.74 3h-2.6l-4.869 5.688L9.3 3zm3.84 2h2.049l9.777 14h-2.031z"
    />
    <path
      fill="currentcolor"
      d="m9.325 2.95.015.022 3.935 5.633 4.827-5.637.015-.018h2.732l-.07.082-6.267 7.346 7.455 10.672h-7.032l-.015-.022-4.28-6.117-5.221 6.121-.015.018H2.632l.07-.082L9.4 13.137 2.271 2.95zm.138 10.19L2.74 21h2.64l5.265-6.17L14.96 21h6.91l-7.42-10.625L20.74 3h-2.6l-4.869 5.688L9.3 3H2.367zm8.57 5.86h-2.031L6.207 5h2.049zm-2.005-.05h1.91L8.229 5.05H6.303z"
    />
    <path
      fill="currentcolor"
      d="m9.404 2.8.045.065.014.02 3.824 5.475 4.701-5.49.014-.016.045-.054h3.128l-.212.248-.07.082-6.192 7.257L22.255 21.2h-7.4l-.045-.065-.014-.022-4.167-5.957-5.096 5.974v-.001l-.013.016-.045.055h-3.17l.213-.248.07-.082 6.621-7.743L1.983 2.8zm-7.133.15L9.4 13.137l-6.697 7.83-.07.083h2.772l.015-.018 5.222-6.12 4.279 6.116.015.022h7.032l-7.455-10.672 6.266-7.346.07-.082h-2.73l-.015.018-4.828 5.637L9.34 2.972l-.015-.022zm5.958 2.1 9.709 13.9h-1.91L6.303 5.05zm7.877 13.75h1.543L8.151 5.2h-1.56z"
    />
  </svg>
);
export default SvgCompanyX;
